import { yup } from '@guiker/shared-framework'

export const changePayInMethodSchema = yup.object({
  payInMethodId: yup.string().required(),
})
